import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import { STATUS_API } from 'src/app/constant/config';
import { transferSeller } from 'src/features/deviceSlice';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import { getListStaff } from 'src/features/staffSlice';

const TransferSeller = ({ open, onClose, rowsSelected }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const statusTransfer = useSelector(state => state.agencySlice.statusTransfer);
  const listStaff = useSelector(state => state.staffSlice.listStaff);
  const {isAgency, agencyId} = useSelector(state => state.authSlice);

  // Ensure listStaff is an array, handle different possible structures
  const staffArray = Array.isArray(listStaff)
    ? listStaff
    : listStaff?.data || listStaff?.items || [];

  const listSeller = staffArray.map(item => {
    return {
      id: item.id,
      fullName: item.full_name
    }
  });

  useEffect(() => {
    if (isAgency) dispatch(getListStaff({ id: agencyId, data: { page: 1, page_size: 1000 } }))
  }, [isAgency]);

  const handleSubmit = (data) => {
    if (data.staff_id) {
      dispatch(
        transferSeller({
          id: Number(data.staff_id),
          data: { list_device_ids: rowsSelected }
        })
      );
    }
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <CustomDialog title="Chuyển thiết bị" open={open} onClose={handleClose} sizeSmall={true}>
      <div>
        <Formik
          initialValues={{ staff_id: '' }}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            staff_id: Yup.string()
              .max(100)
              .required('Tên nhân viên không được để trống'),
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <InputLabel style={{ marginBottom: "21px" }}>
                    Chọn người bán <span className="text-danger"></span>
                  </InputLabel>

                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={listSeller || []}
                    getOptionLabel={option => option.fullName}
                    value={(listSeller || []).find(
                      option => option.id === values.staff_id
                    )}
                    onChange={(e, value) => setFieldValue('staff_id', value.id)}
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn người bán"
                        name="staff_id"
                        helperText={touched.staff_id && errors.staff_id}
                        error={Boolean(
                          touched.staff_id && errors.staff_id
                        )}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px',
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />

                </Grid>
              </Grid>
              <Box my={3}>
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '15px',
                    '& .left-button': {
                      display: 'flex'
                    }
                  }}
                >
                  <Button
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    onClick={() => onClose()}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                  >
                    Thoát
                  </Button>
                  <Button
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Chuyển xuống
                  </Button>
                  {statusTransfer === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    },
  }
}));

export default React.memo(TransferSeller);
